import Cookies from 'universal-cookie';
import CookieKey from './enums';
import { getDefaultCookieOptions } from './defaultOptions';

const cookies = new Cookies();
const maxTokenCookieAge = 14000; // 3.8 hrs

export const storeAuthToken = (token: string): void => {
  const cookieOptions = {
    ...getDefaultCookieOptions(),
    maxAge: maxTokenCookieAge,
  };

  cookies.set(CookieKey.OAUTH_TOKEN, token, cookieOptions);
};

export const removeAuthToken = (): void => {
  cookies.remove(CookieKey.OAUTH_TOKEN, getDefaultCookieOptions());
};

export const getAuthToken = (): string | undefined => {
  return cookies.get(CookieKey.OAUTH_TOKEN);
};
